export default __webpack_public_path__ + "svgs/trustpilotStar-8cacb60c.svg";